<template>
  <rj-tabs v-model="tabsActive">
    <rj-tab-pane name="1" label="已确认下单合同">
      <!-- 新增  已确认下单合同组件 -->
      <Approval-List />
    </rj-tab-pane>
    <rj-tab-pane name="2" label="待申请发货">
      <!-- 新增  待审请发货组件 -->
      <Consignment-List />
    </rj-tab-pane>
    <rj-tab-pane name="3" label="已申请发货单">
      <international-invoice-has-been-applied />
    </rj-tab-pane>
  </rj-tabs>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import ApprovalList from './components/ApprovalList';
import ConsignmentList from './components/InternationalPendingApprovalPleaseShip.vue';
import InternationalInvoiceHasBeenApplied from './components/InternationalInvoiceHasBeenApplied.vue';
export default {
  data () {
    return {
      nums: {
        submit: 0,
        notAllocated: 0
      }
    };
  },

  components: {
    InternationalInvoiceHasBeenApplied,
    ApprovalList,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    // 待审请发货组件
    ConsignmentList
  },

  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.OrderPersionInterContractListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETOrderPersionInterContractListTabActive', val);
      }
    }
  },

  methods: {
    totalNumber (val) {
      this.nums.submit = val;
    }
  }
};
</script>
<style>
</style>
